export type TrialOfferApiData = {
  offerKey: string;
  targetPlanId: string;
  trialExpiry: string;
  activatedAt: string;
  autoUpgrade: boolean;
  canceledAt?: string;
  canceledBy?: 'customer' | 'admin';
  upgradedAt?: string;
  upgradeFailedAt?: string;
  failureReason?: string;
};

export const TRIAL_OFFER_ERROR_CODES = [
  'trial_offer_not_available',
  'trial_offer_not_allowed_for_customer',
  'trial_offer_billing_system_not_supported',
  'trial_offer_invoicing_not_allowed',
  'trial_offer_no_subscription',
  'trial_offer_already_availed',
  'trial_offer_billing_period_not_eligible',
  'trial_offer_plan_not_eligible',
  'trial_offer_discount_not_allowed',
  'trial_offer_target_plan_not_found',
  'trial_offer_not_found',
  'trial_offer_already_settled',
] as const;

export type TrialOfferErrorCode = typeof TRIAL_OFFER_ERROR_CODES[number];

// `offer` does not mean eligible: billing-details carries `trialOffer` only after activation,
// so eligibility is only known from the POST response.
export type TrialOfferState = 'offer' | 'active' | 'availed' | 'no-billing-access';

export type TrialOfferProgress = {
  targetPlanId: string;
  trialExpiry: string;
  daysLeft: number;
  canceled: boolean;
};

export type TrialOfferDialogData = {
  offerKey: string;
};
